
import { MapLocation } from '@/types/location';

// Qeuz Gaming Center Locations
export const qeuzGamingCenters: MapLocation[] = [
  {
    id: 56001,
    name: "Qeuz Gaming Center - Riyadh (Al Rabee)",
    type: "Game Center",
    devices: 4,
    coordinates: [24.804866181640804, 46.66090859325296],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "17-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
